import scrapSuccess from '../../../assets/scrapSuccess.png';

export default function AddLectureSuccessIcon() {
  return (
      <img src={scrapSuccess} alt='' />
  );
}